<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    mounted: function () {
      this.$store.dispatch('SET_LANGUAGE', this.$route.query)
      this.$store.dispatch('LOGIN_USER', this.$route.query)
      if (this.$route.query.language !== undefined && this.$route.query.language.length !== 0 && this.$route.query.language === 'en') {
        this.$i18n.locale = 'en'
      }
    }
  }
</script>

<style>
  @import "assets/css/common.css";
</style>